import CompatibilityAPI from '@/api/compatibility'

const DASHBOARD_SOURCE_KEY = 'web_dashboard';

const state = {
    version: null,
    need_reload: false
};

const mutations = {
    setVersion(state, payload) {
        state.version = payload;
    },
    setNeedReload(state, payload) {
        state.need_reload = payload;
    }
}

const actions = {
    init(context) {
        CompatibilityAPI.getCurrent(DASHBOARD_SOURCE_KEY).then(data => {
            context.commit('setVersion', data.version);

            setInterval(() => {
                context.dispatch('check');
            }, 60 * 1000);
        }).catch(error => {
            console.error(error);
        });
    },
    check(context) {
        CompatibilityAPI.check(
            DASHBOARD_SOURCE_KEY,
            context.state.version
        ).then(data => {
            if (!data.is_supported) {
                context.commit('setNeedReload', true);
                setTimeout(() => {
                    window.location.reload();
                }, 30 * 1000);
            }
        }).catch(error => {
            console.error(error);
        })
    }
}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}